import { io } from 'socket.io-client';
import { getCMSAPIUrl } from './utils/urlFactory';

const socket = io(getCMSAPIUrl(), {
    withCredentials: true,
    extraHeaders: {
        'my-custom-header': 'abcd',
    },
});

export default socket;